import { gql } from '@apollo/client';

const RESTRICTION_FRAGMENT = gql`
  fragment restrictionFragment on Restriction {
    id
    type
    value
    hasBeenApproved
  }
`;

export { RESTRICTION_FRAGMENT };
